<ion-header>
  <div class="left">
    <div class="back-button" (click)="onBackButtonClick()">
      <app-svg-icon [name]="'arrow-back'"></app-svg-icon>
    </div>
    <div class="title">
      {{ "@pages.about.header" | translate }}
    </div>
  </div>
</ion-header>
<div class="padding-md wrap">
  <div class="list">
    <a href="mailto:{{ appConfig.contactEmail }}">
      <app-list-item-button
        [isButton]="true"
        [header]="'@pages.about.list.contactEmail' | translate"
        [text]="appConfig.contactEmail"
      ></app-list-item-button>
    </a>
    <a href="tel:{{ appConfig.contactPhone }}">
      <app-list-item-button
        [isButton]="true"
        [header]="'@pages.about.list.contactPhone' | translate"
        [text]="appConfig.contactPhone | phone : 'bg'"
      ></app-list-item-button>
    </a>
    <a
      href="{{
        appConfig.privacyPolicyUrls[(languageService.currentLang | async)!]
      }}"
      target="_blank"
    >
      <app-list-item-button
        [isButton]="true"
        [header]="'@pages.about.list.privacyPolicy' | translate"
      ></app-list-item-button>
    </a>
    <app-list-item-button
      [isButton]="true"
      [header]="'@pages.about.list.termsOfUse' | translate"
      (click)="onTermsOfUseClick()"
    ></app-list-item-button>
    <app-list-item-button
      [isButton]="true"
      [header]="'@pages.about.list.imprint' | translate"
      (click)="onImprintClick()"
    ></app-list-item-button>
    <app-list-item-button
      [header]="'@pages.about.list.appVersion' | translate"
      [text]="(platformService.getAppVersion() | async)!"
    ></app-list-item-button>
  </div>
</div>
